// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"30":"e13e14ae","455":"cbcdce39","977":"3f5982d4"}[chunkId] + ".chunk.js";
};